import LoginIcon from '@mui/icons-material/Login';
import React from 'react';
import { signIn } from '../utils/authenticate';
import { captureError } from '../utils/capture-error';
import { ALLIANCE_THRESHOLDS } from './alliance/alliance-tokens';
import { SystemScreen, SystemSplash } from './alliance/system-screen';

/**
 * A protected route for an anonymous visitor: stores the path and sends
 * them to the Cognito Hosted UI, showing the branded splash meanwhile. If
 * the redirect throws, or the page is still here after
 * ALLIANCE_THRESHOLDS.signInFailureMs, it says so with Try again instead
 * of leaving the splash up.
 */
export function RedirectSignIn() {
  // State
  const [failed, setFailed] = React.useState(false);
  const [attempt, setAttempt] = React.useState(0);

  React.useEffect(() => {
    // The redirect normally unloads the page; if it hasn't, it failed
    const timer = window.setTimeout(
      () => setFailed(true),
      ALLIANCE_THRESHOLDS.signInFailureMs,
    );

    const handleSignIn = async () => {
      try {
        await signIn({ window });
      } catch (error) {
        captureError({ data: { error } });
        window.clearTimeout(timer);
        setFailed(true);
      }
    };

    handleSignIn();
    return () => window.clearTimeout(timer);
  }, [attempt]);

  if (failed) {
    return (
      <SystemScreen
        layout="inline"
        tone="error"
        icon={<LoginIcon />}
        title="We couldn’t start sign-in"
        body={<p>You need to sign in to see this page. Please try again.</p>}
        primaryAction={{
          label: 'Try again',
          onClick: () => {
            setFailed(false);
            setAttempt((current) => current + 1);
          },
        }}
      />
    );
  }

  return <SystemSplash caption="Opening sign-in…" />;
}
